import isObject_default from "./isObject.js";
import _isPrototype_default from "./_isPrototype.js";
import _nativeKeysIn_default from "./_nativeKeysIn.js";

//#region ../../node_modules/lodash-es/_baseKeysIn.js
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
* The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
*
* @private
* @param {Object} object The object to query.
* @returns {Array} Returns the array of property names.
*/
function baseKeysIn(object) {
	if (!isObject_default(object)) return _nativeKeysIn_default(object);
	var isProto = _isPrototype_default(object), result = [];
	for (var key in object) if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
	return result;
}
var _baseKeysIn_default = baseKeysIn;

//#endregion
export { _baseKeysIn_default as default };
//# sourceMappingURL=_baseKeysIn.js.map